import { useMutation, useQueryClient } from '@tanstack/react-query';
import { App } from 'antd';

import { cartKey, clearStoreCartOptions } from '@lib/api/options/cart';
import { MutationCallbackOptions } from '@lib/api/options/types';
import { getRateLimitMessage } from '@lib/utils/error-handler';

export const useClearStoreCart = () => {
  const { message } = App.useApp();
  const queryClient = useQueryClient();
  const { mutateAsync: execute, isPending } = useMutation(
    clearStoreCartOptions(),
  );

  const onClearStoreCart = (
    storeId: string,
    options?: MutationCallbackOptions<Awaited<ReturnType<typeof execute>>>,
  ) =>
    execute(storeId, {
      onSuccess: () => {
        queryClient
          .invalidateQueries({ queryKey: cartKey })
          .catch(() => undefined);
        options?.onCompleted?.();
      },
      onError: (error) => {
        message.error(
          getRateLimitMessage(error) ??
            'Não foi possível limpar este carrinho.',
        );
        options?.onError?.(error);
      },
    });

  return {
    clearStoreCart: onClearStoreCart,
    clearingStoreCart: isPending,
  };
};
